"use client";
'use strict';

var useRollbar = require('./useRollbar.js');

function useRollbarConfiguration(config) {
  var rollbar = useRollbar.useRollbar();
  rollbar.configure(config);
}

exports.useRollbarConfiguration = useRollbarConfiguration;
//# sourceMappingURL=useRollbarConfiguration.js.map
